export default function LoadingDots({
  label,
  containerClassName,
  labelClassName,
  dotsClassName,
}) {
  return (
    <div className={containerClassName} role="status" aria-live="polite">
      {label ? <div className={labelClassName}>{label}</div> : null}
      <div className={dotsClassName} aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
